// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"724e3f1f","59":"0f7fae5a","215":"cde58c1e","310":"e1cb96a9","320":"a7d9a224","727":"01dfa4a1","793":"002a52e8","967":"223d0e47"}[chunkId] + ".chunk.js";
};